'use client';

import React, { FC, useCallback } from 'react';
import { useRouter } from 'next/navigation';

import { Avatar } from '../(member)/_components/Avatar';
import { WelcomeForm } from '../(member)/welcome/_components/welcome-form';

import { Button } from 'components/ui/button';

import { useTelegramMiniApp } from 'app/_context/TelegramContext';
import { UserNode } from 'generated/types';
import { MEMBER_ROUTES } from 'utils/routes';
import { CurrentUserType } from 'types';

interface IProfileCreationContent {
  user?: CurrentUserType | null;
  onSuccess?: () => void;
}

export const ProfileCreationContent: FC<IProfileCreationContent> = ({ user, onSuccess }) => {
  const router = useRouter();
  const { isEnabledTWA } = useTelegramMiniApp();

  const handleManually = useCallback(() => {
    void router.push(MEMBER_ROUTES.ONB_180_BASIC.getPath());
    onSuccess?.();
  }, [router, onSuccess]);

  return (
    <div className="flex flex-col items-center text-center flex-1">
      {!isEnabledTWA && (
        <Avatar
          width={90}
          height={90}
          avatar={user?.image}
          user={user as UserNode}
          alt={`${user?.firstName} ${user?.lastName}`}
          containerClassname="shadow-lg border-4 border-white mb-[30px] text-display-md text-gray-500 font-semibold"
          defaultIconHeight={60}
          defaultIconWidth={60}
        />
      )}
      <>
        <p className='text-display-lg text-brand-950 font-semibold mb-3 md:text-display-sm md:mb-1'>
          Create your profile <br />with LinkedIn
        </p>
        <div className='flex w-full gap-8 flex-col text-left'>
          <WelcomeForm onSuccess={onSuccess} />
          <div className={'flex max-w-[427px] mx-auto gap-8 flex-col md:gap-6'}>
            <p className='text-[12px]/[18px] text-gray-600 text-center '>
              By providing your LinkedIn profile, you acknowledge and consent to the use of your profile and
              associated data for the purposes of account setup, configuration, and ongoing maintenance.
            </p>
            <div className='flex items-center gap-2'>
              <div className='flex-1 border-b border-b-gray-200' />
              <span className='text-medium text-gray-600'>OR</span>
              <div className='flex-1 border-b border-b-gray-200' />
            </div>
            <Button variant='darkBrand' size='small' className={'px-[60px] mx-auto gap-3'}
                    onClick={handleManually}>
              Fill out manually
            </Button>
          </div>
        </div>
      </>
    </div>
  );
};